module.exports = __webpack_public_path__ + "img/popup_economy_pay_select.3c906e79.png";